export const blockIconsNotificationSupportAgent = (
	<span className='material-symbols-outlined'>support_agent</span>
);
